import { render, staticRenderFns } from "./PersonList.vue?vue&type=template&id=ca021424&"
import script from "./PersonList.vue?vue&type=script&lang=ts&"
export * from "./PersonList.vue?vue&type=script&lang=ts&"
import style0 from "./PersonList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports